<ng-template #sessionTimeoutModal let-c="close" let-d="dismiss">
	<div id="session-timeout-modal">
		<div class="modal-header">
			<h4 class="modal-title" [innerHTML]="'sessionTimeOut.modal.title' | translate"></h4>
			<button type="button" class="close" aria-label="Close" (click)="c('Cross click')">
				<cfe-icon [iconName]="'close'"></cfe-icon>
			</button>
		</div>
		<div class="d-flex justify-content-center">
			<img class="modal-icon" src="assets/images/info.png" alt="Modal info icon" />
		</div>
		<div
			class="modal-body"
			[innerHTML]="'sessionTimeOut.modal.message' | translate: { sessionTimeout: round(sessionTimeOutInSeconds) }"
		></div>
		<div class="modal-body" [innerHTML]="'sessionTimeOut.modal.remaining' | translate: { seconds: secondsRemaining }"></div>
		<div class="align-items-center modal-footer">
			<button type="button" class="btn btn-primary" id="config-button-confirm" (click)="c('Confirm click')">
				{{ 'sessionTimeOut.modal.button_continue' | translate }}
			</button>
			<button type="button" class="btn btn-primary mt-2 mt-sm-0" (click)="d('Cancel click')" id="a-cancel">
				{{ 'sessionTimeOut.modal.button_logout' | translate }}
			</button>
		</div>
	</div>
</ng-template>
